import { ArSettingsView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

/** Settings · AI Brain › Accounts receivable — rebuilt (amendment 28 §6). Four
 * blocks; everything that used to live here (pools, lanes, timing, overrides) is
 * gone. Who gets followed up is set per follow-up. */
export function SettingsArPage() {
  const navigate = useNavigate();
  return <ArSettingsView onOpenFollowUps={() => { void navigate('/collections/follow-ups'); }} />;
}
